import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { SiteLayout, lireProfil, ecrireProfil } from './SiteLayout';
import { STOCK } from './stockPhotos';
import { Hero3D } from './Hero3D';
import { API_URL } from '../../config';
import { fetchRealisations, mapReal, videoInfo } from './realData';
import { useSiteSettings } from './siteSettings';
import { ChoixProfil, BandeauProfil, FormulaireProjet, DONNEURS, RappelExpress, DispoBadge } from './Offres';

const IMG = (n) => `${process.env.PUBLIC_URL}/img/${n}.webp`;
const PUB = process.env.PUBLIC_URL;

/* ════════════════════════════════════════════════════════════
   VIDÉOS — pour ajouter une vidéo :
   1) mettre le fichier .mp4 dans frontend/public/videos/
   2) ajouter une ligne ici  { src:'/videos/mon-chantier.mp4', poster:'/videos/mon-chantier.jpg', titre:'...', lieu:'...' }
   Ou une vidéo YouTube :   { youtube:'ID_YOUTUBE', titre:'...', lieu:'...' }
   ════════════════════════════════════════════════════════════ */
export const VIDEOS = [
  {
    src: '/videos/evolink-chantiers-pv.mp4',
    poster: '/videos/evolink-chantiers-pv.jpg',
    titre: 'EVOLINK — Nos chantiers photovoltaïques',
    lieu: 'Hangars · Toitures · Ombrières — pose, câblage, onduleurs',
    duree: '0:26',
  },
  {
    src: '/videos/evolink-soustraitance-pv.mp4',
    poster: '/videos/evolink-soustraitance-pv.jpg',
    titre: 'EVOLINK — Sous-traitance photovoltaïque',
    lieu: 'Toitures industrielles · Hangars · Ombrières — de la pose à la mise en service',
    duree: '0:41',
  },
];

/* ════════════════════════════════════════════════════════════
   ILS NOUS FONT CONFIANCE — ajouter ici les donneurs d'ordre (avec leur accord).
   Logo : mettre le fichier dans frontend/public/img/clients/ et indiquer logo:'/img/clients/nom.png'
   Tant que la liste est vide, la section ne s'affiche pas.
   ════════════════════════════════════════════════════════════ */
export const CLIENTS = [
  // { nom: 'Nom du client', logo: '/img/clients/nom.png' },
];

const SLIDES = [
  { img: IMG('toiture-industrielle'), kicker: 'Votre partenaire national · Partout en France', title: <>Sous-traitance<br/><span>photovoltaïque</span></>, sous: 'Nous accompagnons les installateurs et EPC dans la réalisation de leurs chantiers photovoltaïques partout en France.', tags: ['Hangars agricoles', 'Toitures industrielles', 'Ombrières', 'Centrales au sol'] },
  { img: IMG('hangar-vue'),      kicker: 'Pose · Câblage · Mise en service', title: <>De 100 kWc<br/><span>à 1 MWc</span></>, tags: ['Ombrières', 'Hangars', 'Centrales au sol'] },
  { img: IMG('ch-hangar-campagne'),         kicker: 'Qualité & sécurité chantier', title: <>Des équipes<br/><span>qualifiées</span></>, tags: ['Contrôles', 'Essais', 'Réception'] },
];


const FAQ = [
  {
    "q": "Travaillez-vous avec les particuliers ?",
    "r": "Oui. EVOLINK installe pour les particuliers (panneaux solaires, borne de recharge, pompe à chaleur, électricité), pour les professionnels (entreprises, commerces, agriculteurs, copropriétés) et travaille en sous-traitance pour les EPC, installateurs et opérateurs. Sur les chantiers de nos donneurs d'ordre, leur client reste le leur : nous ne le démarchons jamais."
  },
  {
    "q": "Quelle taille de chantier prenez-vous en charge ?",
    "r": "Principalement des centrales de 100 kWc à 1 MWc : ombrières de parking, hangars agricoles, toitures industrielles et tertiaires, centrales au sol."
  },
  {
    "q": "Quelles prestations pouvez-vous réaliser ?",
    "r": "Tout ou partie de l'exécution : calepinage et implantation, pose des structures et des modules, chemins de câbles, câblage DC/AC, mise à la terre, contrôles et assistance à la mise en service."
  },
  {
    "q": "Dans quelles régions intervenez-vous ?",
    "r": "Partout en France. Nos équipes sont mobiles et habituées aux grands déplacements."
  },
  {
    "q": "Quels systèmes de fixation maîtrisez-vous ?",
    "r": "Notamment K2 Systems, Schletter, Esdec, Joris Ide, Novotegra, Soprasolar, Dome Solar, Genelios, ISY PV et EPC Solaire."
  },
  {
    "q": "Comment sont suivis les chantiers ?",
    "r": "Autocontrôles à chaque étape, reporting photo quotidien à votre conducteur de travaux et DOE photo en fin de chantier."
  },
  {
    "q": "Sous quel délai recevez-vous un chiffrage ?",
    "r": "Sous 48 h ouvrées à réception des plans, du DCE et du planning souhaité."
  }
];


const CSS = `
/* HERO */
.h-hero{position:relative;height:calc(100vh - 126px);min-height:560px;max-height:860px;overflow:hidden;background:var(--ev-navy2)}
.h-slide{position:absolute;inset:0;opacity:0;transition:opacity 1.2s ease}
.h-slide.on{opacity:1}
.h-slide img{width:100%;height:100%;object-fit:cover;transform:scale(1.08);transition:transform 7s ease-out}
.h-slide.on img{transform:scale(1)}
.h-over{position:absolute;inset:0;background:linear-gradient(90deg,rgba(7,18,58,.92) 0%,rgba(7,18,58,.65) 45%,rgba(7,18,58,.15) 100%)}
.h-content{position:absolute;inset:0;display:flex;align-items:center}
.h-inner{max-width:680px}
.h-kick{display:inline-block;font-family:var(--ev-h);font-weight:700;font-size:.8rem;letter-spacing:.22em;text-transform:uppercase;color:var(--ev-sun);margin-bottom:18px}
.h-title{font-weight:900;font-size:clamp(2.4rem,6vw,4.6rem);line-height:1.02;color:#fff;letter-spacing:-.01em;text-transform:uppercase}
.h-title span{color:var(--ev-sun)}
.h-tags{display:flex;gap:10px;flex-wrap:wrap;margin:26px 0 38px}
.h-tags span{padding:8px 16px;border:1px solid rgba(255,255,255,.35);color:#fff;font-family:var(--ev-h);font-weight:600;font-size:.78rem;letter-spacing:.08em;text-transform:uppercase;border-radius:2px;backdrop-filter:blur(4px)}
.h-anim>*{opacity:0;transform:translateY(24px);transition:all .8s cubic-bezier(.16,1,.3,1)}
.h-slide.on .h-anim>*{opacity:1;transform:none}
.h-slide.on .h-anim>*:nth-child(2){transition-delay:.12s}
.h-slide.on .h-anim>*:nth-child(3){transition-delay:.24s}
.h-slide.on .h-anim>*:nth-child(4){transition-delay:.36s}
.h-dots{position:absolute;bottom:34px;left:0;right:0;z-index:5}
.h-dots .ev-wrap{display:flex;gap:10px}
.h-dot{width:42px;height:4px;background:rgba(255,255,255,.35);border:none;cursor:pointer;padding:0;transition:background .3s}
.h-dot.on{background:var(--ev-sun)}
.h-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:50px;height:50px;border:1px solid rgba(255,255,255,.35);background:rgba(7,18,58,.3);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .2s}
.h-arrow:hover{background:var(--ev-sun);color:var(--ev-navy);border-color:var(--ev-sun)}

/* CHIFFRES */
.h-stats{position:relative;z-index:6;margin-top:24px}
.h-offre{padding:22px 0 82px}
.h-stats-grid{display:grid;grid-template-columns:repeat(4,1fr);background:#fff;box-shadow:0 20px 50px rgba(11,27,77,.12)}
.h-stat{padding:30px 26px;border-right:1px solid var(--ev-line);display:flex;gap:16px;align-items:center}
.h-stat:last-child{border-right:none}
.h-stat b{font-family:var(--ev-h);font-weight:900;font-size:1.7rem;color:var(--ev-blue);line-height:1;white-space:nowrap}
.h-stat small{display:block;font-size:.8rem;color:var(--ev-muted);line-height:1.4}

/* A PROPOS */
.h-about{display:grid;grid-template-columns:1fr 1fr;gap:70px;align-items:center}
.h-about-imgs{position:relative;height:540px}
.h-about-imgs img{position:absolute;object-fit:cover;box-shadow:0 20px 50px rgba(11,27,77,.18)}
.h-about-imgs .a1{left:0;top:0;width:70%;height:78%}
.h-about-imgs .a2{right:0;bottom:0;width:52%;height:55%;border:8px solid #fff}
.h-badge{position:absolute;left:24px;bottom:24px;background:var(--ev-sun);color:var(--ev-navy);padding:22px 26px;font-family:var(--ev-h);z-index:2}
.h-badge b{display:block;font-weight:900;font-size:2.6rem;line-height:1}
.h-badge span{font-weight:700;font-size:.75rem;letter-spacing:.12em;text-transform:uppercase}
.h-checks{display:grid;grid-template-columns:1fr 1fr;gap:12px 24px;margin:30px 0 36px}
.h-check{display:flex;gap:10px;align-items:flex-start;font-size:.93rem;color:var(--ev-ink);font-weight:500}
.h-check i{flex-shrink:0;width:22px;height:22px;border-radius:50%;background:var(--ev-blue);color:#fff;display:flex;align-items:center;justify-content:center;font-style:normal;font-size:.7rem;margin-top:1px}

/* COMPETENCES */
.h-cards{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:56px}
.h-card{background:#fff;padding:40px 34px;position:relative;overflow:hidden;border-bottom:4px solid transparent;transition:all .35s;box-shadow:0 4px 20px rgba(11,27,77,.05)}
.h-card:hover{transform:translateY(-6px);border-bottom-color:var(--ev-sun);box-shadow:0 24px 50px rgba(11,27,77,.12)}
.h-card-n{position:absolute;top:18px;right:24px;font-family:var(--ev-h);font-weight:900;font-size:3.4rem;color:var(--ev-bg2);line-height:1;transition:color .35s}
.h-card:hover .h-card-n{color:rgba(245,179,1,.18)}
.h-card-ico{width:64px;height:64px;background:var(--ev-blue);color:#fff;display:flex;align-items:center;justify-content:center;margin-bottom:26px;transition:background .35s}
.h-card:hover .h-card-ico{background:var(--ev-sun);color:var(--ev-navy)}
.h-card h3{font-weight:800;font-size:1.15rem;color:var(--ev-navy);margin-bottom:12px;position:relative}
.h-card p{font-size:.92rem;line-height:1.8;color:var(--ev-muted);position:relative}

/* VIDEOS */
.h-vid-grid{display:grid;grid-template-columns:1.6fr 1fr;gap:40px;align-items:center;margin-top:56px}
.h-player{position:relative;background:#000;aspect-ratio:16/9;box-shadow:0 30px 70px rgba(0,0,0,.45);border:1px solid rgba(255,255,255,.08)}
.h-player video,.h-player iframe,.h-player img{width:100%;height:100%;display:block;object-fit:cover;border:0}
.h-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:linear-gradient(0deg,rgba(7,18,58,.55),rgba(7,18,58,.1));cursor:pointer;border:none;width:100%}
.h-play-btn{width:92px;height:92px;border-radius:50%;background:var(--ev-sun);display:flex;align-items:center;justify-content:center;position:relative;transition:transform .25s}
.h-play-btn::before{content:'';position:absolute;inset:-12px;border-radius:50%;border:2px solid rgba(245,179,1,.5);animation:hping 2s infinite}
@keyframes hping{0%{transform:scale(.9);opacity:1}100%{transform:scale(1.35);opacity:0}}
.h-play:hover .h-play-btn{transform:scale(1.08)}
.h-vid-steps{list-style:none;margin:28px 0 0;padding:0}
.h-vid-steps li{display:flex;gap:16px;align-items:center;padding:14px 0;border-bottom:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.85);font-size:.95rem}
.h-vid-steps li b{font-family:var(--ev-h);color:var(--ev-sun);font-weight:800;font-size:.8rem;letter-spacing:.1em}
.h-vid-list{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:18px;margin-top:40px}
.h-vid-item{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);cursor:pointer;text-align:left;padding:0;color:#fff;transition:border-color .2s}
.h-vid-item.on,.h-vid-item:hover{border-color:var(--ev-sun)}
.h-vid-item img{width:100%;aspect-ratio:16/9;object-fit:cover;display:block}
.h-vid-item div{padding:12px 14px;font-family:var(--ev-h);font-weight:700;font-size:.85rem}

/* SPLIT (ombrières / hangars) */
.h-split{display:grid;grid-template-columns:1fr 1fr;min-height:520px}
.h-split-img{position:relative;overflow:hidden;min-height:380px}
.h-split-img img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:transform 6s}
.h-split:hover .h-split-img img{transform:scale(1.05)}
.h-split-txt{padding:80px 70px;display:flex;flex-direction:column;justify-content:center}
.h-split-txt ul{list-style:none;padding:0;margin:24px 0 0}
.h-split-txt li{padding:9px 0 9px 26px;position:relative;font-size:.95rem;color:var(--ev-muted)}
.h-split-txt li::before{content:'';position:absolute;left:0;top:16px;width:12px;height:3px;background:var(--ev-sun)}
.h-split.rev .h-split-img{order:2}
.h-split.navy .h-split-txt{background:var(--ev-navy)}
.h-split.navy li{color:rgba(255,255,255,.78)}
.h-split-meta{display:flex;gap:30px;margin-top:30px;flex-wrap:wrap}
.h-split-meta b{display:block;font-family:var(--ev-h);font-weight:900;font-size:1.6rem;color:var(--ev-blue)}
.h-split.navy .h-split-meta b{color:var(--ev-sun)}
.h-split-meta small{font-size:.78rem;color:var(--ev-muted);text-transform:uppercase;letter-spacing:.1em}
.h-split.navy .h-split-meta small{color:rgba(255,255,255,.55)}

.h-photos{display:grid;grid-template-columns:repeat(4,1fr);grid-auto-rows:220px;gap:12px;margin-top:40px}
.h-photo{position:relative;overflow:hidden;display:block;background:var(--ev-navy)}
.h-photo.big{grid-column:span 2;grid-row:span 2}
.h-photo img{width:100%;height:100%;object-fit:cover;transition:transform .6s}
.h-photo:hover img{transform:scale(1.06)}
.h-photo span{position:absolute;left:0;right:0;bottom:0;padding:26px 14px 12px;background:linear-gradient(0deg,rgba(7,18,58,.85),transparent);color:#fff;font-family:var(--ev-h);font-weight:700;font-size:.85rem}
@media(max-width:900px){.h-photos{grid-template-columns:1fr 1fr;grid-auto-rows:180px}}
.h-types{display:grid;grid-template-columns:repeat(4,1fr);gap:18px;margin-top:48px}
.h-type{position:relative;display:block;height:340px;overflow:hidden;text-decoration:none}
.h-type img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:transform .7s}
.h-type:hover img{transform:scale(1.07)}
.h-type::after{content:'';position:absolute;inset:0;background:linear-gradient(0deg,rgba(7,18,58,.92),rgba(7,18,58,.05) 65%)}
.h-type div{position:absolute;left:22px;right:22px;bottom:20px;z-index:1;color:#fff}
.h-type span{font-family:var(--ev-h);font-weight:700;font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;color:var(--ev-sun)}
.h-type h3{font-weight:900;font-size:1.3rem;margin:6px 0 8px;color:#fff}
.h-type em{font-style:normal;font-family:var(--ev-h);font-weight:700;font-size:.78rem;letter-spacing:.06em;text-transform:uppercase;opacity:.85}
@media(max-width:1000px){.h-types{grid-template-columns:1fr 1fr}}
@media(max-width:560px){.h-types{grid-template-columns:1fr}.h-type{height:240px}}
/* POURQUOI */
.h-why{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-top:56px}
.h-why-item{text-align:center;padding:10px 12px}
.h-why-ico{width:86px;height:86px;border-radius:50%;margin:0 auto 22px;border:2px dashed var(--ev-sun);display:flex;align-items:center;justify-content:center}
.h-why-ico span{width:64px;height:64px;border-radius:50%;background:var(--ev-blue);color:#fff;display:flex;align-items:center;justify-content:center;font-family:var(--ev-h);font-weight:900;font-size:1.3rem}
.h-why-item h3{font-weight:800;font-size:1.05rem;color:var(--ev-navy);margin-bottom:10px}
.h-why-item p{font-size:.9rem;line-height:1.75;color:var(--ev-muted)}

/* PROCESS */
.h-proc{display:grid;grid-template-columns:repeat(4,1fr);gap:0;margin-top:60px;position:relative}
.h-proc::before{content:'';position:absolute;top:38px;left:12.5%;right:12.5%;height:2px;background:repeating-linear-gradient(90deg,var(--ev-sun) 0 10px,transparent 10px 18px)}
.h-proc-step{text-align:center;padding:0 18px;position:relative}
.h-proc-n{width:78px;height:78px;margin:0 auto 24px;background:var(--ev-navy);color:#fff;border:4px solid #fff;box-shadow:0 0 0 2px var(--ev-sun);border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:var(--ev-h);font-weight:900;font-size:1.4rem;position:relative;z-index:1;transition:background .3s}
.h-proc-step:hover .h-proc-n{background:var(--ev-sun);color:var(--ev-navy)}
.h-proc-step h3{font-weight:800;font-size:1.05rem;color:var(--ev-navy);margin-bottom:10px;text-transform:uppercase;letter-spacing:.04em}
.h-proc-step p{font-size:.9rem;line-height:1.75;color:var(--ev-muted)}

/* SYSTEMES */
.h-sys{display:flex;flex-wrap:wrap;justify-content:center;gap:12px;margin-top:34px}
.h-sys span{padding:12px 22px;border:1px solid var(--ev-line);background:#fff;font-family:var(--ev-h);font-weight:800;font-size:.8rem;letter-spacing:.1em;color:var(--ev-navy)}

/* CTA */
.h-cta{position:relative;padding:100px 0;overflow:hidden}
.h-cta img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
.h-cta::after{content:'';position:absolute;inset:0;background:linear-gradient(90deg,rgba(0,47,167,.95),rgba(11,27,77,.85))}
.h-cta .ev-wrap{position:relative;z-index:1;display:flex;justify-content:space-between;align-items:center;gap:40px;flex-wrap:wrap}

.rv{opacity:0;transform:translateY(30px);transition:opacity .8s ease,transform .8s cubic-bezier(.16,1,.3,1)}
.rv.in{opacity:1;transform:none}

@media(max-width:1000px){
  .h-stats-grid{grid-template-columns:1fr 1fr}
  .h-stat:nth-child(2){border-right:none}
  .h-stat:nth-child(-n+2){border-bottom:1px solid var(--ev-line)}
  .h-about,.h-vid-grid{grid-template-columns:1fr;gap:48px}
  .h-cards{grid-template-columns:1fr 1fr}
  .h-split,.h-split.rev{grid-template-columns:1fr}
  .h-split.rev .h-split-img{order:0}
  .h-split-txt{padding:56px 24px}
  .h-why{grid-template-columns:1fr 1fr;gap:40px 20px}
  .h-proc{grid-template-columns:1fr 1fr;gap:44px 0}
  .h-proc::before{display:none}
  .h-arrow{display:none}
}
@media(max-width:600px){
  .h-hero{height:88vh}
  .h-stats{margin-top:0}
  .h-offre{padding:22px 0}
  .h-stat{padding:18px 14px;flex-direction:column;align-items:flex-start;gap:6px}
  .h-stat b{font-size:1.35rem}
  .h-about-imgs{height:380px}
  .h-cards,.h-checks{grid-template-columns:1fr}
  .h-card{padding:32px 26px}
}
`;

/* Apparition au scroll */
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.rv');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}


function CountUp({ value }) {
  const m = String(value).match(/^(\d+)(.*)$/);
  const target = m ? parseInt(m[1], 10) : null;
  // Valeur finale affichée d'emblée (Google, aperçus, pré-rendu ne voient jamais « 0 ») ; l'animation ne joue que si le compteur arrive à l'écran en défilant
  const [v, setV] = useState(target === null ? value : target);
  const ref = useRef();
  useEffect(() => {
    if (target === null || !ref.current || /HeadlessChrome|bot|crawl|spider/i.test(navigator.userAgent)) return;
    let premier = true;
    const obs = new IntersectionObserver(([e]) => {
      if (premier) { premier = false; if (e.isIntersecting) { obs.disconnect(); return; } setV(0); return; }
      if (!e.isIntersecting) return;
      obs.disconnect();
      const t0 = performance.now();
      const tick = (now) => {
        const k = Math.min((now - t0) / 1600, 1);
        setV(Math.round(target * (1 - Math.pow(1 - k, 3))));
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target]);
  return <span ref={ref} data-final={value}>{target === null ? value : `${v}${m[2]}`}</span>;
}

function Hero() {
  const [i, setI] = useState(0);
  const timer = useRef();
  const go = (n) => { setI((n + SLIDES.length) % SLIDES.length); };
  useEffect(() => {
    timer.current = setInterval(() => setI(v => (v + 1) % SLIDES.length), 6500);
    return () => clearInterval(timer.current);
  }, [i]);

  return (
    <section className="h-hero">
      {SLIDES.map((s, k) => (
        <div key={k} className={`h-slide${k === i ? ' on' : ''}`} aria-hidden={k !== i}>
          <img src={s.img} alt="" loading={k === 0 ? 'eager' : 'lazy'} />
          <div className="h-over" />
          <div className="h-content">
            <div className="ev-wrap" style={{ width:'100%' }}>
              <div className="h-inner h-anim">
                <span className="h-kick">{s.kicker}</span>
                {k === 0 ? <h1 className="h-title">{s.title}</h1> : <div className="h-title" role="heading" aria-level="2">{s.title}</div>}
                {s.sous && <p style={{ color: 'rgba(255,255,255,.85)', maxWidth: 620, lineHeight: 1.7, margin: '0 0 18px', fontSize: '1.05rem' }}>{s.sous}</p>}
                <div className="h-tags">{s.tags.map(t => <span key={t}>{t}</span>)}</div>
                <div style={{ display:'flex', gap:14, flexWrap:'wrap' }}>
                  <Link to="/devis" className="ev-btn ev-btn-sun">Demander un devis</Link>
                  <Link to="/references-photovoltaique" className="ev-btn ev-btn-ghost">Nos références</Link>
                </div>
                <Link to="/visite-technique" style={{ display: 'inline-block', marginTop: 14, color: 'rgba(255,255,255,.8)', fontSize: '.9rem' }}>🏠 Particulier en Nouvelle-Aquitaine ? Visite gratuite →</Link>
              </div>
            </div>
          </div>
        </div>
      ))}
      <button className="h-arrow" style={{ left:24 }} onClick={() => go(i - 1)} aria-label="Précédent">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <button className="h-arrow" style={{ right:24 }} onClick={() => go(i + 1)} aria-label="Suivant">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
      </button>
      <div className="h-dots"><div className="ev-wrap">
        {SLIDES.map((_, k) => <button key={k} className={`h-dot${k === i ? ' on' : ''}`} onClick={() => go(k)} aria-label={`Slide ${k + 1}`} />)}
      </div></div>
    </section>
  );
}

function Videos() {
  const [cur, setCur] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [dyn, setDyn] = useState([]);
  const vref = useRef();
  // Vidéos ajoutées depuis l'admin (Réalisations → lien ou fichier vidéo) : affichées en premier
  useEffect(() => {
    fetchRealisations().then(d => setDyn(d.map(mapReal).filter(r => r.video && r.accueil).map(r => {
      const vi = videoInfo(r.video);
      return vi.kind === 'file'
        ? { url: vi.src, poster: r.imgs[0] || '', titre: r.titre, lieu: [r.type, r.puissance, r.lieu, r.duree].filter(Boolean).join(' · '), abs: true }
        : { embed: vi.embed.replace('autoplay=1', 'autoplay=0'), thumb: vi.thumb || r.imgs[0] || '', titre: r.titre, lieu: [r.type, r.puissance, r.lieu, r.duree].filter(Boolean).join(' · ') };
    })));
  }, []);
  const LIST = [...dyn, ...VIDEOS];
  const v = LIST[cur] || VIDEOS[0];

  const play = () => {
    setPlaying(true);
    setTimeout(() => vref.current && vref.current.play().catch(() => {}), 50);
  };

  return (
    <section id="videos" className="ev-sec dark" style={{ scrollMarginTop:90 }}>
      <div className="ev-wrap">
        <div className="ev-center rv">
          <span className="ev-kicker">En vidéo</span>
          <h2 className="ev-title">Ce que nous faisons <span>sur le terrain</span></h2>
          <p className="ev-lead">De la pose des modules jusqu'à la mise en service : découvrez nos équipes en action sur nos chantiers de sous-traitance photovoltaïque.</p>
        </div>

        <div className="h-vid-grid rv">
          <div className="h-player">
            {v.youtube || v.embed ? (
              <iframe src={v.embed || `https://www.youtube-nocookie.com/embed/${v.youtube}?rel=0`} title={v.titre} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            ) : playing ? (
              <video ref={vref} src={v.abs ? v.url : PUB + v.src} poster={v.poster ? (v.abs ? v.poster : PUB + v.poster) : undefined} controls playsInline preload="metadata" />
            ) : (
              <>
                {v.poster ? <img src={v.abs ? v.poster : PUB + v.poster} alt={v.titre} loading="lazy" /> : <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg,#0B1B4D,#002FA7)' }} />}
                <button className="h-play" onClick={play} aria-label="Lire la vidéo">
                  <span className="h-play-btn">
                    <svg width="34" height="34" viewBox="0 0 24 24" fill="#0B1B4D" style={{ marginLeft:5 }}><path d="M6 4l15 8-15 8z"/></svg>
                  </span>
                </button>
              </>
            )}
          </div>

          <div>
            <h3 style={{ fontWeight:800, fontSize:'1.35rem', color:'#fff', marginBottom:8 }}>{v.titre}</h3>
            <p style={{ color:'rgba(255,255,255,.6)', fontSize:'.9rem' }}>{v.lieu}{v.duree ? ` · ${v.duree}` : ''}</p>
            <ul className="h-vid-steps">
              {['Pose des modules', 'Tirage des câbles DC', 'Chemins de câbles', 'Contrôles & essais', 'Mise en service'].map((s, k) => (
                <li key={s}><b>0{k + 1}</b>{s}</li>
              ))}
            </ul>
            <Link to="/nos-realisations" className="ev-btn ev-btn-sun" style={{ marginTop:30 }}>Toutes nos réalisations →</Link>
          </div>
        </div>

        {LIST.length > 1 && (
          <div className="h-vid-list">
            {LIST.map((x, k) => (
              <button key={k} className={`h-vid-item${k === cur ? ' on' : ''}`} onClick={() => { setCur(k); setPlaying(false); }}>
                {(x.thumb || x.poster || x.youtube) ? <img src={x.thumb || (x.youtube ? `https://img.youtube.com/vi/${x.youtube}/hqdefault.jpg` : (x.abs ? x.poster : PUB + x.poster))} alt="" loading="lazy" /> : <span style={{ display: 'block', height: 70, background: '#002FA7' }} />}
                <div>▶ {x.titre}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}


/* Dernières réalisations publiées depuis l'espace admin (masqué s'il n'y en a aucune) */
function DernieresRealisations() {
  const [list, setList] = useState([]);
  useEffect(() => { fetchRealisations().then(d => setList(d.map(mapReal).filter(r => r.accueil && (r.imgs.length || r.video)).slice(0, 6))); }, []);
  if (!list.length) return null;
  return (
    <section className="ev-sec alt">
      <div className="ev-wrap">
        <div className="ev-center">
          <span className="ev-kicker">Nos dernières réalisations</span>
          <h2 className="ev-title">Chantiers <span>récemment livrés</span></h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 22, marginTop: 40 }}>
          {list.map(r => {
            const img = r.imgs[0] || videoInfo(r.video)?.thumb;
            return (
              <Link key={r.id} to={`/nos-realisations?r=${r.rid}`} style={{ display: 'block', background: '#fff', textDecoration: 'none', boxShadow: '0 8px 30px rgba(11,27,77,.08)', overflow: 'hidden' }}>
                <div style={{ position: 'relative', height: 220, background: 'var(--ev-navy)' }}>
                  {img && <img src={img} alt={r.titre} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
                  <span style={{ position: 'absolute', top: 14, left: 14, background: 'var(--ev-sun)', color: 'var(--ev-navy)', fontFamily: 'var(--ev-h)', fontWeight: 800, fontSize: '.7rem', letterSpacing: '.08em', textTransform: 'uppercase', padding: '5px 10px' }}>{r.type}</span>
                  {r.video && <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 58, height: 58, borderRadius: '50%', background: 'rgba(245,179,1,.95)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><svg width="24" height="24" viewBox="0 0 24 24" fill="#0B1B4D" style={{ marginLeft: 3 }}><path d="M6 4l15 8-15 8z" /></svg></span>}
                  {r.puissance && <span style={{ position: 'absolute', bottom: 14, left: 14, color: '#fff', fontFamily: 'var(--ev-h)', fontWeight: 900, fontSize: '1.4rem', textShadow: '0 2px 10px rgba(0,0,0,.6)' }}>{r.puissance}</span>}
                </div>
                <div style={{ padding: '18px 20px 22px' }}>
                  <h3 style={{ fontWeight: 800, color: 'var(--ev-navy)', fontSize: '1.05rem', marginBottom: 6 }}>{r.titre}</h3>
                  <div style={{ fontSize: '.88rem', color: 'var(--ev-muted)', display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {r.lieu && <span>📍 {r.lieu}</span>}{r.duree && <span>⏱ {r.duree}</span>}{r.mois && <span>📅 {r.mois}</span>}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        <div className="ev-center" style={{ marginTop: 34 }}><Link to="/nos-realisations" className="ev-btn ev-btn-blue">Toutes nos réalisations →</Link></div>
      </div>
    </section>
  );
}

/* Témoignages réels saisis dans l'admin (section masquée s'il n'y en a aucun) */
function Temoignages() {
  const [list, setList] = useState([]);
  useEffect(() => {
    let ok = true;
    fetch(API_URL + '/config/site/temoignages').then(r => (r.ok ? r.json() : [])).then(d => { if (ok && Array.isArray(d)) setList(d.slice(0, 6)); }).catch(() => {});
    return () => { ok = false; };
  }, []);
  if (!list.length) return null;
  return (
    <section className="ev-sec alt">
      <div className="ev-wrap">
        <div className="ev-center">
          <span className="ev-kicker">Ils nous font confiance</span>
          <h2 className="ev-title">Ce que disent <span>nos donneurs d'ordre</span></h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 20, marginTop: 40 }}>
          {list.map(t => (
            <figure key={t.id} style={{ margin: 0, background: '#fff', padding: '28px 26px', boxShadow: '0 8px 30px rgba(11,27,77,.07)', borderTop: '4px solid var(--ev-sun)' }}>
              <div style={{ color: 'var(--ev-sun)', fontSize: '1.1rem', letterSpacing: 2 }}>{'★'.repeat(Math.max(1, Math.min(5, t.note || 5)))}</div>
              <blockquote style={{ margin: '12px 0 16px', lineHeight: 1.8, color: 'var(--ev-ink)', fontStyle: 'italic' }}>« {t.message} »</blockquote>
              <figcaption style={{ fontFamily: 'var(--ev-h)', fontWeight: 800, color: 'var(--ev-navy)', fontSize: '.9rem' }}>
                {t.nom}{t.entreprise ? <span style={{ fontWeight: 500, color: 'var(--ev-muted)' }}> — {t.entreprise}</span> : null}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section className="ev-sec" id="faq" style={{ scrollMarginTop: 90 }}>
      <div className="ev-wrap" style={{ maxWidth: 900 }}>
        <div className="ev-center rv">
          <span className="ev-kicker">Questions fréquentes</span>
          <h2 className="ev-title">Tout savoir sur notre <span>sous-traitance</span></h2>
        </div>
        <div style={{ marginTop: 40 }}>
          {FAQ.map((f, k) => (
            <div key={k} style={{ background: '#fff', marginBottom: 10, boxShadow: '0 3px 14px rgba(11,27,77,.06)', borderLeft: `4px solid ${open === k ? 'var(--ev-sun)' : 'var(--ev-line)'}` }}>
              <button onClick={() => setOpen(open === k ? -1 : k)} aria-expanded={open === k}
                style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, padding: '20px 24px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'var(--ev-h)', fontWeight: 800, fontSize: '1rem', color: 'var(--ev-navy)' }}>
                {f.q}<span style={{ fontSize: '1.4rem', color: 'var(--ev-blue)', flexShrink: 0 }}>{open === k ? '−' : '+'}</span>
              </button>
              {open === k && <p style={{ padding: '0 24px 22px', lineHeight: 1.8, color: 'var(--ev-muted)' }}>{f.r}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* 3D sur ordinateur uniquement : sur téléphone, la photo (plus rapide) */
const grandEcran = () => { try { return window.matchMedia('(min-width: 900px)').matches && !(navigator.connection && navigator.connection.saveData); } catch (e) { return false; } };

export function SiteHome() {
  useEffect(() => {
    let s = document.getElementById('ev-home-css');
    if (!s) { s = document.createElement('style'); s.id = 'ev-home-css'; document.head.appendChild(s); }
    s.textContent = CSS;
  }, []);
  useReveal();
  const S = useSiteSettings();
  const [profil, setProfil] = useState(lireProfil());
  return (
    <SiteLayout>
      {grandEcran() ? <Hero3D Fallback={Hero} /> : <Hero />}
      <BandeauProfil profil={profil} onChanger={() => { ecrireProfil(''); setProfil(''); setTimeout(() => { const el = document.getElementById('profil'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 50); }} />

      {!profil && <ChoixProfil />}

      {/* Chiffres clés (pas de chevauchement quand un bandeau de profil est affiché au-dessus) */}
      <div className="h-stats">
        <div className="ev-wrap">
          <div className="h-stats-grid">
            {[
              { v: '100 kWc', s: 'à 1 MWc par projet' },
              { v: S.mwc, s: S.mwc_label },
              { v: S.chiffrage, s: 'pour un chiffrage' },
              { v: 'France', s: 'sous-traitance · pros · particuliers' },
            ].map((x, k) => (
              <div key={k} className="h-stat"><b><CountUp value={x.v} /></b><small>{x.s}</small></div>
            ))}
          </div>
        </div>
      </div>

      {/* EPC / donneurs d'ordre : demande express */}
      <section id="epc" className="ev-sec" style={{ scrollMarginTop: 80, background: 'linear-gradient(135deg,#0B1B4D,#002FA7)' }}>
        <div className="ev-wrap" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 40, alignItems: 'center' }}>
          <div style={{ color: '#fff' }}>
            <span className="ev-kicker" style={{ color: 'var(--ev-sun)' }}>EPC · installateurs · développeurs · opérateurs</span>
            <h2 className="ev-title light" style={{ color: '#fff' }}>Un chantier à staffer ? <span>Chiffrage sous 48 h</span></h2>
            <ul style={{ lineHeight: 2, paddingLeft: 18, marginTop: 14, color: 'rgba(255,255,255,.88)' }}>
              <li>Équipes de pose PV : structures, modules, câblage DC/AC, mise en service</li>
              <li>500 kWc posés en 12 à 15 jours selon le site</li>
              <li>Autocontrôles photo, DOE, suivi en ligne</li>
              <li>RGE QualiPV 500 · 55 MWc installés · partout en France</li>
              <li>Fibre FTTH : raccordements, fourreaux bouchés, tranchées</li>
            </ul>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 16 }}>
              <Link to="/reserver-equipe" className="ev-btn ev-btn-sun">📅 Réserver une équipe en ligne</Link>
              <Link to="/dossier-fournisseur" className="ev-btn ev-btn-ghost">🗂 Dossier fournisseur en 1 clic</Link>
            </div>
            <DispoBadge clair />
            <RappelExpress clair />
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 18 }}>
              <a href={`${PUB}/docs/EVOLINK-plaquette-sous-traitance-PV.pdf`} target="_blank" rel="noopener noreferrer" className="ev-btn ev-btn-ghost">📄 Plaquette PDF</a>
              <Link to="/documents" className="ev-btn ev-btn-ghost">🗂 Kbis, décennale, URSSAF</Link>
              <Link to="/references-photovoltaique" className="ev-btn ev-btn-ghost">🏗 Nos références</Link>
            </div>
          </div>
          <FormulaireProjet profil="donneur" titre="Envoyez votre projet" type="Photovoltaïque" types={['Photovoltaïque', ...Object.values(DONNEURS).map(x => x.nom)]} />
        </div>
      </section>

      {/* À propos */}
      <section className="ev-sec">
        <div className="ev-wrap h-about">
          <div className="h-about-imgs rv">
            <img className="a1" src={IMG('toiture-modules-cables')} alt="Toiture photovoltaïque posée par EVOLINK" loading="lazy" />
            <img className="a2" src={IMG('controle')} alt="Contrôles électriques" loading="lazy" />
            <div className="h-badge"><b>10 ans</b><span>d'expérience</span></div>
          </div>
          <div className="rv">
            <span className="ev-kicker">À propos d'EVOLINK</span>
            <h2 className="ev-title">Votre sous-traitant <span>photovoltaïque</span> partout en France</h2>
            <p className="ev-lead">
              EVOLINK accompagne les EPC, installateurs et développeurs du secteur photovoltaïque sur leurs projets tertiaires, industriels et agricoles, et équipe aussi en direct entreprises, agriculteurs et particuliers.
              En <strong style={{ color:'var(--ev-navy)' }}>sous-traitance</strong>, votre client reste le vôtre : nous réalisons l'exécution sur le chantier et ne le démarchons jamais.
            </p>
            <div className="h-checks">
              {['Pose de structures & modules', 'Câblage DC / AC', 'Contrôles & mise en service', 'Fibre optique FTTH'].map(t => (
                <div key={t} className="h-check"><i>✓</i>{t}</div>
              ))}
            </div>
            <Link to="/qui-sommes-nous" className="ev-btn ev-btn-blue">En savoir plus →</Link>
          </div>
        </div>
      </section>

      {/* Nos métiers */}
      <section className="ev-sec alt">
        <div className="ev-wrap">
          <div className="ev-center rv">
            <span className="ev-kicker">Nos métiers</span>
            <h2 className="ev-title">Ce que nous <span>faisons</span></h2>
          </div>
          <div className="h-types">
            {[
              { to: '/sous-traitance-photovoltaique', img: IMG('toiture-industrielle'), p: 'Activité principale · EPC', t: 'Sous-traitance photovoltaïque' },
              { to: '/fibre-optique-ftth-gironde', img: STOCK.fibreFils, p: 'Opérateurs · entreprises', t: 'Fibre optique FTTH' },
              { to: '/professionnels', img: IMG('hangar-vue'), p: 'Entreprises · agriculteurs', t: 'Solaire, bornes et électricité pros' },
              { to: '/particuliers', img: STOCK.poseursToit, p: 'Particuliers', t: 'Panneaux solaires, borne, PAC' },
            ].map(t => (
              <Link key={t.to} to={t.to} className="h-type rv">
                <img src={t.img} alt={t.t} loading="lazy" />
                <div><span>{t.p}</span><h3>{t.t}</h3><em>Découvrir →</em></div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Vidéos */}
      <Videos />

      <DernieresRealisations />

      {/* Ils nous font confiance */}
      {CLIENTS.length > 0 && (
        <section className="ev-sec" style={{ paddingTop: 70, paddingBottom: 70 }}>
          <div className="ev-wrap ev-center">
            <span className="ev-kicker">Ils nous font confiance</span>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 40, marginTop: 30 }}>
              {CLIENTS.map(c => c.logo
                ? <img key={c.nom} src={PUB + c.logo} alt={c.nom} style={{ height: 56, maxWidth: 180, objectFit: 'contain', filter: 'grayscale(1)', opacity: .8 }} />
                : <span key={c.nom} style={{ fontFamily: 'var(--ev-h)', fontWeight: 900, fontSize: '1.2rem', color: 'var(--ev-navy)', letterSpacing: '.04em' }}>{c.nom}</span>)}
            </div>
          </div>
        </section>
      )}

      {S.google_note && (
        <div style={{ background: '#fff', padding: '26px 0', borderBottom: '1px solid var(--ev-line)' }}>
          <div className="ev-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 900, fontSize: '1.1rem', color: 'var(--ev-navy)' }}><span style={{ color: '#4285F4' }}>G</span><span style={{ color: '#EA4335' }}>o</span><span style={{ color: '#FBBC05' }}>o</span><span style={{ color: '#4285F4' }}>g</span><span style={{ color: '#34A853' }}>l</span><span style={{ color: '#EA4335' }}>e</span></span>
            <span style={{ fontSize: '1.6rem', fontWeight: 900, color: 'var(--ev-navy)' }}>{S.google_note}</span>
            <span style={{ color: '#F5B301', fontSize: '1.3rem', letterSpacing: 2 }}>{'★'.repeat(Math.round(Number(String(S.google_note).replace(',', '.')) || 5))}</span>
            {S.google_nb && <span style={{ color: 'var(--ev-muted)' }}>{S.google_nb} avis</span>}
            {S.google_url && <a href={S.google_url} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--ev-blue)', fontWeight: 800 }}>Voir les avis →</a>}
          </div>
        </div>
      )}
      <Temoignages />

      <Faq />

      {/* CTA */}
      <section className="h-cta">
        <img src={IMG('hangar-vue')} alt="" loading="lazy" />
        <div className="ev-wrap">
          <div>
            <span className="ev-kicker" style={{ color:'var(--ev-sun)' }}>Un chantier à lancer ?</span>
            <h2 className="ev-title light">Un projet ? <span>Parlons-en</span></h2>
            <p style={{ color:'rgba(255,255,255,.75)', marginTop:14, fontSize:'1rem' }}>Pros : chiffrage sous 48 h ouvrées. Particuliers : visite technique gratuite.</p>
          </div>
          <div style={{ display:'flex', gap:14, flexWrap:'wrap' }}>
            <Link to="/devis" className="ev-btn ev-btn-sun">Nous consulter →</Link>
            <Link to="/visite-technique" className="ev-btn ev-btn-ghost">🏠 Visite gratuite (particuliers)</Link>
            <a href="tel:+33666887766" className="ev-btn ev-btn-ghost">📞 06 66 88 77 66</a>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}

export default SiteHome;
